module.exports = __webpack_public_path__ + "assets/videos/video-header.mp4?v=816f2c5a";